export const tableConfig = {
  columns: [
    {
      id: "name",
      name: "Name",
    },
    {
      id: "control",
      name: "",
    },
  ],
};

export const ROWS_PER_PAGE = 17;

export const INITIAL_SORTING_ID = "name";

export const ASCENDING_ORDER = "asc";

export const DESCENDING_ORDER = "desc";
